import { UserColumns } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Button } from '@mui/material';
import React from 'react';
import { ReloadUsersTableContext } from '../contexts/ReloadUsersTableContext';
import { useHandleEditUser } from '../hooks/useHandleEditUser';
import { useHandleRemoveUser } from '../hooks/useHandleRemoveUser';

export const UserActions: React.FC<{ row: Row<UserColumns> }> = ({ row }) => {
    const { t } = useTranslation();
    const reload = React.useContext(ReloadUsersTableContext);
    const handleEditUser = useHandleEditUser(row, reload);
    const handleRemoveUser = useHandleRemoveUser(row, reload);
    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant='outlined' size='small' startIcon={<EditOutlinedIcon />} onClick={handleEditUser}>
                {t('edit')}
            </Button>
            <Button variant='outlined' size='small' startIcon={<RemoveCircleOutlineIcon />} onClick={handleRemoveUser}>
                {t('remove')}
            </Button>
        </Box>
    );
};
